import React from "react";

const SpamSuggestions = ({
  spamMatches,
  showSuggestions,
  setShowSuggestions,
  fieldValue,
  onReplace,
  SPAM_SUGGESTIONS,
}) => {
  if (spamMatches.length === 0) return null;

  return (
    <>
      <div className="mt-1 rounded border border-yellow-300 bg-yellow-100 text-yellow-900 text-sm relative">
        <div className="flex justify-between items-start px-4 pt-3 pb-2">
          <div className="flex-1 pr-2">
            <strong className="text-yellow-800">⚠️ Spam Alert:</strong>{" "}
            {spamMatches.length} Potential Keyword
            {spamMatches.length > 1 ? "s" : ""} Detected – Try Our Suggested
            Alternatives Below.
          </div>
          <button
            type="button"
            onClick={() => setShowSuggestions((prev) => !prev)}
            className="text-yellow-800 hover:text-yellow-600 text-lg"
            aria-label="Toggle Suggestions"
          >
            <i
              className={`pi ${
                showSuggestions ? "pi-chevron-up" : "pi-chevron-down"
              }`}
              style={{ fontSize: "1rem" }}
            />
          </button>
        </div>
      </div>

      {showSuggestions && (
        <div className="bg-white px-4 py-2 space-y-3 border rounded shadow-lg relative z-10">
          {spamMatches.map((word) => (
            <div
              key={word}
              className="flex justify-between items-center flex-wrap gap-3 border-b last:border-b-0 py-2"
            >
              <div className="flex items-center gap-2 flex-wrap">
                <span className="italic text-gray-700">{word}</span>
                <span>→</span>
                <span className="text-cyan-700 font-medium bg-cyan-100 px-3 py-1 rounded-md">
                  {SPAM_SUGGESTIONS[word] || "Try different wording"}
                </span>
              </div>
              <div className="ml-auto">
                <button
                  type="button"
                  className="px-3 py-1 rounded text-white bg-teal-600 hover:bg-teal-700 transition"
                  onClick={() => onReplace(word)}
                >
                  Replace
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default SpamSuggestions;